"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsScaffold() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Scaffold
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Root wrapper component for application pages providing portal container and background support.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/scaffold" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Usage</CardTitle>
              <CardDescription>Wrap your app with Scaffold for proper portal handling</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="bg-muted/50 rounded-lg p-4 font-mono text-sm overflow-x-auto">
            <code className="block">{"import { Scaffold } from \"@/registry/new-york/ui/scaffold\";"}</code>
            <code className="block mt-4">{"export default function App() {"}</code>
            <code className="block pl-4">{"return ("}</code>
            <code className="block pl-8">{"<Scaffold>"}</code>
            <code className="block pl-12">{"<YourAppContent />"}</code>
            <code className="block pl-8">{"</Scaffold>"}</code>
            <code className="block pl-4">{");"}</code>
            <code className="block">{"}"}</code>
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Features</CardTitle>}
          contentClassName="p-6"
        >
          <ul className="space-y-2 text-sm">
            <li>• Provides a portal container for modals, tooltips, and popovers</li>
            <li>• Ensures proper z-index stacking</li>
            <li>• Supports background customization</li>
            <li>• Handles scroll locking for overlays</li>
          </ul>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">children</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Application content</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">className</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Additional CSS classes</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
